import React, { useContext, useState, useEffect, MouseEventHandler } from 'react';
import { UserContext } from '../UserContext';
import { PageContext } from '../PageContext';
import { Col, Container, Row } from 'reactstrap';
import { Button, Toolbar, ToolbarItem } from '@progress/kendo-react-buttons';
import { Grid, GridColumn, GridCellProps, GridDataStateChangeEvent, GridPageChangeEvent,getSelectedState,GridSelectionChangeEvent} from '@progress/kendo-react-grid';
import { Input,Checkbox, CheckboxChangeEvent, InputChangeEvent, Switch, SwitchChangeEvent } from '@progress/kendo-react-inputs';
import { DatCatSizeDataItem, upDatCatSizeDataItem, SiteEntry, upSiteEntry } from '../../services/interfaces';
import { deleteSite, getAdminSiteList, saveSite } from '../../services/apiAdminService';
import { process, State, DataResult } from '@progress/kendo-data-query';
import { getter } from '@progress/kendo-react-common';
import { PagerTargetEvent } from '@progress/kendo-react-data-tools';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Label } from '@progress/kendo-react-labels';
import { data } from 'react-router-dom';
import { ConfirmDialog } from '../ConfirmDialog';
import { SiteList, StatusList } from '../FormComponents';

interface PageState {
    skip: number;
    take: number;
}

const initialPageState: PageState = { skip: 0, take: 20 };

const initialDataState: State = {
    sort: [{ field: 'category', dir: 'asc' }],
    filter: undefined,
    skip:0,
    take:20

};

interface editProps{
    site:SiteEntry,
    title: string,
    onClose: () => void;
    action:string
}

export interface NewSite
{
    code:string,
    name:string,
    logo_Prefix:string,
    primary_ip:string,
    backup_ip:string,
    temp_Char:string,
    temp_Int:string,
    vol1_Unc_Path:string,
    vol2_Unc_Path:string
}


const EditDialog=(props:editProps)=>{

    const [newSite, setNewSite]= useState<SiteEntry>(
        {
            code:"",
            name:"",
            logo_Prefix:"",
            primary_ip:"",
            backup_ip:"",
            temp_Char:"",
            temp_Int:0,
            vol1_Unc_Path:"",
            vol2_Unc_Path:""
        }
    );
    const [dlgTitle, setDlgTitle]=useState<string>("");
    const [showDelConfirm, setShowDelConfirm]=useState(false);
    const [showDeleteButton, setShowDeleteButton]=useState(true);
    const [intAction,setIntAction]=useState("");
    const [siteValid, setSiteValid]=useState(false);
    const [pubValid, setPubValid]=useState({
        pubNum:false,
        pubName:false,
        pubSite:false
    });
    const setSiteCode=(e: InputChangeEvent)=>{
        setNewSite({...newSite, code: (e.value) || ''})        
    }

    const setSiteName=(e: InputChangeEvent)=>{
        setNewSite({...newSite, name: (e.value)})
    }

    const setSitePrefix=(e: InputChangeEvent)=>{
        setNewSite({...newSite, logo_Prefix: e.value})
    }

    const setPrimaryIP=(e: InputChangeEvent)=>{
        setNewSite({...newSite, primary_ip: e.value})
    }

    const setSecondaryIP=(e: InputChangeEvent)=>{
        setNewSite({...newSite, backup_ip: e.value})
    }
    const setVol1Path=(e: InputChangeEvent)=>{
        setNewSite({...newSite, vol1_Unc_Path: e.value})
    }
    const setVol2Path=(e: InputChangeEvent)=>{
        setNewSite({...newSite, vol2_Unc_Path: e.value})
    }
    const setTeam=(e: InputChangeEvent)=>{
        setNewSite({...newSite, temp_Int: Number(e.value)})
    }
    const setKillPath=(e: InputChangeEvent)=>{
        setNewSite({...newSite, temp_Char: e.value})
    }    

    const validateSite= async()=>{
        var siteValid={
            code:false,
            name:false,
        }
        if (newSite.code!=""){
            siteValid.code=true;
        }
        if (newSite.name!==""){
            siteValid.name=true;
            setSiteValid(true);            
        }
        return siteValid;
    }
    

    const viewDeleteButton=()=>{
        setShowDeleteButton(true);
    }

    const hideDeleteButton=()=>{
        setShowDeleteButton(false);
    }


    const viewDelConfirm=()=>{
        setShowDelConfirm(true);
    }

    const hideDelConfirm=()=>{
        setShowDelConfirm(false);
    }



    const deleteThisSize=()=>{
        if (props.action=="Edit"){
            const code = newSite.code;
            if (code!=""){
                deleteSite(code);
            }
        }        
        hideDelConfirm();
        props.onClose();
    }

    const saveThisSize= async ()=>{
        var oCode;
        validateSite().then((siteValid)=>{
            if (siteValid.code===true && siteValid.name===true){
                if (intAction==="Edit"){
                    //edit existing site
                     oCode=props.site.code;
                }else{
                    //create new site
                    oCode="";
    
                }
                var formData:upSiteEntry = {
                    oCode: oCode,
                    code:newSite.code,
                    name:newSite.name,
                    logo_Prefix:newSite.logo_Prefix||"",
                    primary_ip:newSite.primary_ip||"",
                    backup_ip:newSite.backup_ip||"",
                    temp_Char:newSite.temp_Char||"",
                    temp_Int:newSite.temp_Int||0,
                    vol1_Unc_Path:newSite.vol1_Unc_Path||"",
                    vol2_Unc_Path:newSite.vol2_Unc_Path||""
                };
                console.log(formData);
                saveSite(formData).then((data)=>{
                      console.log(data);
                      props.onClose();
                });    
            }else{
                console.log("Missing fields");
            }    
        })
    }

    useEffect(()=>{
        console.log(newSite);
    },[newSite])

    useEffect(() => {  
        setDlgTitle(props.title);
        console.log(props.site); 
        if (props.site){
            setNewSite({
                code:props.site.code,
                name:props.site.name,
                logo_Prefix:props.site.logo_Prefix,
                primary_ip:props.site.primary_ip,
                backup_ip:props.site.backup_ip,
                temp_Char:props.site.temp_Char,
                temp_Int:props.site.temp_Int,
                vol1_Unc_Path:props.site.vol1_Unc_Path,
                vol2_Unc_Path:props.site.vol2_Unc_Path
            });            
        }
        setIntAction(props.action);
        if (props.action==="Edit"){
            viewDeleteButton();
        }else{
            hideDeleteButton();
        }
    },[]);
    return(
        <>
        <Dialog title={dlgTitle} onClose={props.onClose} width={700} height={"75vh"}>
            {showDelConfirm?<ConfirmDialog title='Delete Sub-status Entry' message='This will permanently delete the selected sub-status entry. This can not be undone. Are you sure you want to continue?' type='WARN' confirmButtonText='Continue' cancelButtonText='Cancel' onClose={hideDelConfirm} onConfirm={deleteThisSize}  ></ConfirmDialog>:null}

            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Site Code:</Label></Col>
                <Col xs="9"><Input value={newSite.code} onChange={setSiteCode} required={true}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Site Name:</Label></Col>
                <Col xs="9"><Input value={newSite.name} onChange={setSiteName} required={true}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Logo Prefix:</Label></Col>
                <Col xs="9"><Input value={newSite.logo_Prefix} onChange={setSitePrefix}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Primary IP:</Label></Col>
                <Col xs="9"><Input value={newSite.primary_ip} onChange={setPrimaryIP}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Backup IP:</Label></Col>
                <Col xs="9"><Input value={newSite.backup_ip} onChange={setSecondaryIP}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Vol 1 UNC Path:</Label></Col>
                <Col xs="9"><Input value={newSite.vol1_Unc_Path} onChange={setVol1Path}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Vol 2 UNC Path:</Label></Col>
                <Col xs="9"><Input value={newSite.vol2_Unc_Path} onChange={setVol2Path}></Input></Col>
            </Row>
             <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Team:</Label></Col>
                <Col xs="9"><Input value={newSite.temp_Int} onChange={setTeam}></Input></Col>
            </Row>
             <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Kill Path:</Label></Col>
                <Col xs="9"><Input value={newSite.temp_Char} onChange={setKillPath}></Input></Col>
            </Row>
            <DialogActionsBar>
                <Button themeColor={"secondary"}onClick={props.onClose}>Cancel</Button>
                <Button themeColor={"primary"} onClick={saveThisSize}>Save</Button>
                {showDeleteButton?<Button themeColor={"warning"} onClick={viewDelConfirm}>Delete</Button>:null}
            </DialogActionsBar>
        </Dialog>
        </>
    )
}

export default function AdminSites (){
    const userContext = useContext(UserContext);
    const pageContext = useContext(PageContext);
    const user = userContext?.user;
    const [sites, setSites] = useState([]);
    const [siteSelected, setSiteSelected]=useState<SiteEntry>();
    const [showEditDialog,setShowEditDialog]=useState(false);
    const [title,setTitle]=useState("");
    const [dataState, setDataState]=useState<State>(initialDataState);
    const [dataResult, setDataResult]=useState<DataResult>(process(sites,dataState));
    const [page, setPage] = React.useState<PageState>(initialPageState);
    const [action,setAction]=useState("Edit");
    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});

    const idGetter = getter('pubNum');


    const hideEditDialog=()=>{
        setShowEditDialog(false);
        getSizes();
    }

    const newEditDialog=(e: React.MouseEvent<HTMLButtonElement>)=>{
        setAction("New");
        setTitle("New Site");
        setSiteSelected( {
            code:"",
            name:"",
            logo_Prefix:"",
            primary_ip:"",
            backup_ip:"",
            temp_Char:"",
            temp_Int:0,
            vol1_Unc_Path:"",
            vol2_Unc_Path:""
        })
        setShowEditDialog(true);
    }



    const getSizes=()=>{
        getAdminSiteList().then(data=>{
            setSites(data);
            //setDataResult(process(data, dataState));
        })
    }

    const onDataStateChange = (e: GridDataStateChangeEvent) => {
        setDataState(e.dataState);
        //setDataResult(process(sites, e.dataState));
    };
    const pageChange = (event: GridPageChangeEvent) => {
        const targetEvent = event.targetEvent as PagerTargetEvent;        
        setPage({
            ...event.page,
            take:20
        });
    }

    const processedData=process(sites,dataState);

    const onSelectionChange = (event: GridSelectionChangeEvent) => {
        console.log("Selection changed");
        console.log(event.startDataItem);
        const site:SiteEntry=event.startDataItem;
        setSiteSelected(site);

        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: "code"
        });
        console.log(Object.keys(newSelectedState)[0]);
        setSelectedState(newSelectedState);
    };

    useEffect(()=>{
        console.log(siteSelected);
        if (siteSelected){
            setTitle("Site Configuration for: " + siteSelected?.name);
            setShowEditDialog(true);
        }
    },[siteSelected])
   
    useEffect(() => {   
        if (user?.loggedIn){
            getSizes();
        }else{
            window.location.replace("/Login");
        }
    }, []);

    return (
        <>
        {user?.loggedIn && user.type==5 ?
        <Container fluid>
            <h2>Site Management</h2>
            <Toolbar>
                <Button title="New Size" themeColor={'primary'} type="button" onClick={newEditDialog}>
                    New Site
                </Button>       
            </Toolbar>
            <Grid
                data = {processedData}
                // data={(dataResult.data.slice(page.skip, page.take + page.skip))?.map((item)=>({
                //     ...item, 'selected':selectedState[idGetter(item)]
                // }))}
                dataItemKey='UID'
                id="siteGrid"
                className='adminGrid'
                sortable={true}
                selectable={{ enabled:true, mode: 'single' }}
                pageable={{
                    buttonCount: 4,
                    info:true,                
                    pageSizeValue: 20
                }}
                {...dataState}
                onDataStateChange={onDataStateChange}
                //onPageChange={pageChange}
                onSelectionChange={onSelectionChange}
                // skip={page.skip}
                // take={page.take}
                // total={dataResult.total}
                reorderable={true}
                filterable={true}
            >
                <GridColumn field='code' title='Site Code' width={150} />
                <GridColumn field='name' title='Site Name'/>
                <GridColumn field='logo_prefix' title='Prefix'/>
                <GridColumn field='primary_ip' title='Primary IP'/>
                <GridColumn field='backup_ip' title='Backup IP'/>
                <GridColumn field='temp_int' title='Team'/>
            </Grid>
            {showEditDialog?
                <EditDialog title={title} site={siteSelected as SiteEntry} onClose={hideEditDialog} action={action}></EditDialog>
            :null
            }
        </Container>
        : <></>}
        </>
    );
}